<template>
  <v-dialog :model-value="isOpen" opacity = "0.5" persistent>
    <template #default>
      <div class="d-flex justify-center mt-6">
        <v-card
          :width="mobile ? '80%' : '40%'"
          color="white"
          elevation="3"
          class="d-flex flex-column"
        >
          <v-toolbar flat density="compact" color="white">
            <div class="d-flex align-center">
              <v-btn icon color="primary" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
            <v-chip variant="tonal" color="primary" v-if="sellerModel.sellerId">
              ID: {{ sellerModel.sellerId }}
            </v-chip>

            <v-spacer />

            <v-btn @click="deleteSeller()" icon color="primary">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-toolbar>
          
          <v-divider></v-divider>

          <v-form ref="form">
            <v-row dense class="pa-8">
              <v-col :cols="mobile ? '12' : '9'">
                  <div>
                      <v-text-field
                        v-model="sellerModel.sellerName"
                        label="Nome"
                        variant="outlined"
                        rounded
                        color="primary"
                        density="compact"
                        :rules="[v => !!v || 'Campo obrigatório']"
                      />
                  </div>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="mt-n6 pb-6 pr-6">
            <div class="d-flex flex-column flex-md-row w-100 justify-end">
              <v-btn
                rounded
                variant="flat"
                @click="close()"
              >
                Cancelar
              </v-btn>
              <v-btn
                rounded
                color="primary"
                class="ml-2"
                variant="elevated"
                @click="save()"
              >
                Salvar
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
  </v-dialog>
</template>


<script>
import { useDisplay } from 'vuetify'

export default {
  setup () {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data: () => ({
    sellerId: ''
  }),
  computed: {
    seller: {
      get() {
        return this.$store.state.seller
      }
    },
    sellerModel: {
      get() {
          return this.$store.state.seller.seller
      },
    },
    isOpen: {
      get() {
        return Boolean(this.$route.params.sellerId || this.$route.name == 'NewSeller')
      },
      set(value) {
        if (!value) {
          this.$router.push({ name: 'SellerGrid' })
        }
      }
    }
  },
  methods: {
    async save() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      const success = await this.$store.dispatch("seller/save")
      if (success) {
        this.$store.commit('seller/setShouldReload', true)
        this.close()
      }
    },
    close() {
      this.$router.push({ name: 'SellerGrid' })
    },
    async deleteSeller() {
      const confirmed = await this.$store.dispatch('systemDialogOptions/confirm', null, { root: true })
      if (!confirmed) 
          return false
        
      const success = await this.$store.dispatch("seller/delete")
      if (success) {
        this.$store.commit('seller/setShouldReload', true)
        this.close()
      }
    }
  },
  watch: {
    '$route.params.sellerId': {
      immediate: true,
      async handler(id) {
        if(id) {
          await this.$store.dispatch('seller/find', id)
        } else {
          this.$store.commit('seller/initForm')
        }
      }
    }
  }
}
</script>
